/** EFKT-MOCK — mirrors datahub's `CaseCategory` (`datahub/cases/models.ts`). No Efkt source. */
export var CaseCategory;
(function (CaseCategory) {
    CaseCategory["Case"] = "CASE";
    CaseCategory["Location"] = "LOCATION";
    CaseCategory["Portrait"] = "PORTRAIT";
    CaseCategory["Group"] = "GROUP";
    CaseCategory["IntroOutro"] = "INTRO_OUTRO";
    CaseCategory["Shop"] = "SHOP";
    CaseCategory["Matterport"] = "MATTERPORT";
    CaseCategory["BeforeAfter"] = "BEFORE_AFTER";
})(CaseCategory || (CaseCategory = {}));
/** EFKT-MOCK — mirrors datahub's `CaseMaterialStatus`. No Efkt source. */
export var CaseMaterialStatus;
(function (CaseMaterialStatus) {
    CaseMaterialStatus["Active"] = "ACTIVE";
    CaseMaterialStatus["Archiving"] = "ARCHIVING";
    CaseMaterialStatus["Restoring"] = "RESTORING";
    CaseMaterialStatus["Archived"] = "ARCHIVED";
})(CaseMaterialStatus || (CaseMaterialStatus = {}));
